/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import functions from "../util/functions";
import ajaxUser from "../util/remote/ajaxUser";

const AuthContext = React.createContext();

export const AuthConsumer = AuthContext.Consumer;
export const AuthProvider = (props) => {
  const [userId, setUserId] = useState(functions.sessionGuard());
  const [permissionLists, setPermissionList] = useState([]);
  const [user, setUser] = useState(false);

  useEffect(() => {
    if (userId) {
      getUserInfo();
    }
  }, [userId]);

  // useEffect(() => {
  //   getUserAccess();
  // }, [user.role_id]);

  

  const getUserInfo = async () => {
    const server_response = await ajaxUser.fetchUserProfile(userId);
    if (server_response.status === "OK") {
      const userDetails = server_response.details;
      setUser(userDetails);
      getUserAccess(userDetails.role_id);
    }
  };

  const getUserAccess = async (role_id) => {
    if (!role_id) return;

    const server_response = await ajaxUser.getRolePermissionCodes(role_id);
    if (server_response.status === "OK") {
      setPermissionList(server_response.details);
    } else {
      setPermissionList([]);
    }
  };

  // const getUserAccess = async () => {
  //   const server_response = await ajaxUser.getRolePermissionCodes(user.role_id);
  //   if (server_response.status === "OK") {
  //     setPermissionList(server_response.details);
  //   } else {
  //     setPermissionList([]);
  //   }
  // };

  return (
    <AuthContext.Provider
      value={{
        user,
        userId,
        permissionLists,
        getUserInfo,
        getUserAccess,
        setUserId
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
